var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"d-flex flex-column",attrs:{"cols":"12","lg":"3"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }